/** Base path for the TAK admin proxy */
export const TAK_BASE = '/api/tak';

/** TAK Marti API endpoint paths (relative to TAK_BASE) */
export const TAK_ENDPOINTS = {
  CONTACTS: '/contacts/all',
  GROUPS: '/groups/all',
  MISSIONS: '/missions',
  VERSION: '/version',
  CLIENT_ENDPOINTS: '/clientEndPoints',
} as const;
